import { Slot } from "radix-ui";
import { cn } from "../utils/index";

// `asChild`, not upstream: a text placeholder sits inside a paragraph, where a div is invalid.
function Skeleton({
  className,
  asChild = false,
  ...props
}: React.ComponentProps<"div"> & { asChild?: boolean }) {
  const Comp = asChild ? Slot.Root : "div";

  return (
    <Comp
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-accent", className)}
      {...props}
    />
  );
}

export { Skeleton };
